import React from 'react'

import { SecondaryNavLayout } from 'src/modules/ui'

import OrderList from './OrderList'
import SingleOrder from './SingleOrder'

const Orders = () => {
  const routes = [
    {
      navLabel: 'New',
      path: `/orders/new`,
      render: props => <OrderList {...props} section="new" />,
    },
    {
      navLabel: 'Dispatched',
      path: `/orders/dispatched`,
      render: props => <OrderList {...props} section="dispatched" />,
    },
    {
      navLabel: 'Approved',
      path: `/orders/approved`,
      render: props => <OrderList {...props} section="approved" />,
    },
    {
      navLabel: 'Issue Raised',
      path: `/orders/disputed`,
      render: props => <OrderList {...props} section="disputed" />,
    },
    {
      navLabel: 'Cancelled',
      path: `/orders/cancelled`,
      render: props => <OrderList {...props} section="cancelled" />,
    },
    {
      path: '/orders/:id/',
      component: SingleOrder,
      title: 'Order',
    },
  ]

  return <SecondaryNavLayout routes={routes} />
}
export default Orders
